import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import placeholderImage from 'assets/img/covers/placeholder.jpg';
import { Wrapper, Video, Image } from './MediaPreview.styles';

const MediaPreview = ({ src, alt, type, autoplay = false, dark = false }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [mediaError, setMediaError] = useState(false);
  const videoRef = useRef(null);
  const isVideo = type === 'video';

  useEffect(() => {
    if (!isVideo || autoplay) return;

    const video = videoRef.current;
    if (!video) return;

    if (isHovered) {
      video.play().catch(() => {});
    } else {
      video.pause();
      video.currentTime = 0;
    }
  }, [isHovered, autoplay, isVideo]);

  return (
    <Wrapper
      $dark={dark}
      onMouseEnter={() => !autoplay && setIsHovered(true)}
      onMouseLeave={() => !autoplay && setIsHovered(false)}
    >
      {isVideo && !mediaError ? (
        <Video
          ref={videoRef}
          src={src}
          muted
          loop
          playsInline
          autoPlay={autoplay}
          onError={() => setMediaError(true)}
        />
      ) : (
        <Image
          src={mediaError ? placeholderImage : src}
          alt={alt}
          onError={() => setMediaError(true)}
        />
      )}
    </Wrapper>
  );
};

MediaPreview.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['image', 'video']).isRequired,
  dark: PropTypes.bool,
  autoplay: PropTypes.bool,
};

export default MediaPreview;
